export class FetchOfferItems {
  static readonly type = '[OfferItems] Load Offer Items';

  constructor(readonly chargeBeeFamillyId: string) {}
}

export class ClearOfferItems {
  static readonly type = '[OfferItems] Clear Offer Items';
}
